"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourTypesPage = void 0;
var React = require("react");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
require("./styles.scss");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
var model_1 = require("../../model");
var constants_1 = require("../../constants");
var server_1 = require("../../helpers/server");
var LOAD_FAILED = 'De uursoorten konden niet worden geladen.';
var SAVE_FAILED = 'De wijziging kon niet worden opgeslagen.';
/**
 * Uursoorten (DMHA-1036)
 *
 * Per company, which work hour and non-work hour types the app users and the
 * portal users may book on. The types themselves come from Business Central;
 * only their availability is managed here.
 *
 * Switching a type off does not touch hours already booked on it - those stay
 * visible but become read-only in the hour control, and may only be changed in
 * the HR system from then on.
 */
var HourTypesPage = /** @class */ (function (_super) {
    __extends(HourTypesPage, _super);
    function HourTypesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.describe = function (hourType) { return hourType.name || hourType.description || '-'; };
        _this.rowKey = function (kind, hourType) { return "".concat(kind, ":").concat(hourType._id); };
        _this.matchesFilter = function (hourType) {
            var needle = _this.state.filterText.trim().toLowerCase();
            if (!needle) {
                return true;
            }
            return "".concat(hourType.code || '').toLowerCase().indexOf(needle) > -1
                || _this.describe(hourType).toLowerCase().indexOf(needle) > -1;
        };
        _this.handleCompanyChange = function (event) {
            _this.setState({ companyId: event.target.value }, function () { return _this.loadHourTypes(); });
        };
        _this.state = {
            companies: [],
            companyId: props.selectedCompanyId || '',
            workTypes: [],
            specialTypes: [],
            filterText: '',
            loading: true,
            saving: [],
            error: null,
        };
        return _this;
    }
    HourTypesPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCompanies()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadHourTypes()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HourTypesPage.prototype.render = function () {
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_HOUR_TYPES, id: "hour-types-page", isLoading: this.state.loading },
            React.createElement(layout_1.Wrapper, { padding: "0 16px 24px 16px" },
                this.renderControls(),
                this.state.error && React.createElement("div", { className: "hour-types__error" }, this.state.error),
                this.renderTable('work', 'Werkuren', this.state.workTypes),
                this.renderTable('special', 'Niet-werkuren', this.state.specialTypes))));
    };
    HourTypesPage.prototype.renderControls = function () {
        var _this = this;
        return (React.createElement("div", { className: "hour-types__controls" },
            React.createElement("label", { className: "hour-types__control" },
                React.createElement("span", null, "Bedrijf"),
                React.createElement("select", { value: this.state.companyId, onChange: this.handleCompanyChange },
                    React.createElement("option", { value: "" }, "Alle bedrijven"),
                    this.state.companies.map(function (company) { return (React.createElement("option", { key: company._id, value: company._id }, company.name)); }))),
            React.createElement("label", { className: "hour-types__control" },
                React.createElement("span", null, "Zoeken"),
                React.createElement("input", { type: "text", value: this.state.filterText, placeholder: "Code of omschrijving", onChange: function (event) { return _this.setState({ filterText: event.target.value }); } })),
            React.createElement("p", { className: "hour-types__hint" }, "Uitgeschakelde uursoorten verdwijnen uit de keuzelijsten. Reeds geboekte uren blijven zichtbaar, maar kunnen daarna alleen nog in het HR-systeem worden gewijzigd.")));
    };
    HourTypesPage.prototype.renderTable = function (kind, title, hourTypes) {
        var _this = this;
        var visible = hourTypes.filter(this.matchesFilter);
        return (React.createElement("div", { className: "hour-types__section" },
            React.createElement("h3", null,
                title,
                " ",
                React.createElement("span", { className: "hour-types__count" },
                    "(",
                    visible.length,
                    ")")),
            !visible.length && !this.state.loading && (React.createElement("div", { className: "hour-types__empty" }, constants_1.NO_DATA_MESSAGE)),
            !!visible.length && (React.createElement("table", { className: "table hour-types__table" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: "hour-types__col-code" }, "Code"),
                        React.createElement("th", null, "Omschrijving"),
                        !this.state.companyId && React.createElement("th", null, "Bedrijf"),
                        React.createElement("th", { className: "hour-types__col-toggle" }, "App-gebruikers"),
                        React.createElement("th", { className: "hour-types__col-toggle" }, "Portaalgebruikers"))),
                React.createElement("tbody", null, visible.map(function (hourType) { return _this.renderRow(kind, hourType); }))))));
    };
    HourTypesPage.prototype.renderRow = function (kind, hourType) {
        var isSaving = this.state.saving.indexOf(this.rowKey(kind, hourType)) > -1;
        return (React.createElement("tr", { key: hourType._id },
            React.createElement("td", { className: "hour-types__col-code" }, hourType.code),
            React.createElement("td", null, this.describe(hourType)),
            !this.state.companyId && React.createElement("td", null, hourType.companyName || '-'),
            React.createElement("td", { className: "hour-types__col-toggle" }, this.renderToggle(kind, hourType, 'availableForApp', isSaving)),
            React.createElement("td", { className: "hour-types__col-toggle" }, this.renderToggle(kind, hourType, 'availableForPortal', isSaving))));
    };
    HourTypesPage.prototype.renderToggle = function (kind, hourType, field, isSaving) {
        var _this = this;
        // A missing flag means available - that is how every type behaved before
        // this page existed, and how the backend reads it too.
        var checked = hourType[field] !== false;
        return (React.createElement("label", { className: "hour-types__toggle" },
            React.createElement("input", { type: "checkbox", checked: checked, disabled: isSaving, onChange: function () { return _this.toggle(kind, hourType, field, !checked); } }),
            React.createElement("span", null, checked ? 'Aan' : 'Uit')));
    };
    HourTypesPage.prototype.loadCompanies = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.COMPANIES_URI, {})];
                    case 1:
                        results = (_a.sent()).results;
                        this.setState({ companies: results || [] });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to load companies', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HourTypesPage.prototype.loadHourTypes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loading: true, error: null });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = this.state.companyId ? { companyId: this.state.companyId } : {};
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.HOUR_TYPES_URI, params)];
                    case 2:
                        response = _a.sent();
                        this.setState({
                            workTypes: response.workTypes || [],
                            specialTypes: response.specialTypes || [],
                            loading: false,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Failed to load hour types', error_2);
                        this.setState({ loading: false, error: LOAD_FAILED });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HourTypesPage.prototype.toggle = function (kind, hourType, field, value) {
        return __awaiter(this, void 0, void 0, function () {
            var key, error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        key = this.rowKey(kind, hourType);
                        this.setState(function (state) { return ({ saving: __spreadArray(__spreadArray([], state.saving, true), [key], false), error: null }); });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, server_1.put)("".concat(constants_1.API.HOUR_TYPES_URI, "/").concat(kind), hourType._id, (_a = {}, _a[field] = value, _a))];
                    case 2:
                        _b.sent();
                        this.applyLocally(kind, hourType._id, field, value);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _b.sent();
                        console.error('Failed to save hour type availability', error_3);
                        this.setState({ error: SAVE_FAILED });
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState(function (state) { return ({ saving: state.saving.filter(function (saved) { return saved !== key; }) }); });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update the one row in place rather than reloading: the list is sorted and a
     * reload would make the table jump under the cursor mid-edit.
     */
    HourTypesPage.prototype.applyLocally = function (kind, id, field, value) {
        var update = function (hourTypes) { return hourTypes.map(function (hourType) {
            var _a;
            return (hourType._id === id ? __assign(__assign({}, hourType), (_a = {}, _a[field] = value, _a)) : hourType);
        }); };
        this.setState(function (state) { return (kind === 'work'
            ? __assign(__assign({}, state), { workTypes: update(state.workTypes) }) : __assign(__assign({}, state), { specialTypes: update(state.specialTypes) })); });
    };
    return HourTypesPage;
}(react_1.Component));
exports.HourTypesPage = HourTypesPage;
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return ({
        // Start on whatever the side menu's company selector is set to.
        selectedCompanyId: reducer.sideMenuReducer && reducer.sideMenuReducer.selectedCompanyId,
    });
};
exports.default = (0, react_redux_1.connect)(mapStateToProps)(HourTypesPage);
